export default __webpack_public_path__ + "static/media/kingbadge.1adf3e19d0f3825441a3f801bee6e2f6.svg";